import React from 'react';
import  ProjectsHeader from '../components/projects-header/index';
import logo from '../logo.png';

export default function ProjectsHeaderContainer ({ children }) {
    return (
        <ProjectsHeader>
            <ProjectsHeader.Frame>
                <ProjectsHeader.Logo to="/" alt="" src={logo} />
            </ProjectsHeader.Frame>
            {children}
        </ProjectsHeader>  
    );
}